import { findRouteMeta } from '@/app/routes/route-meta';

/**
 * The compact chat popup is public browsing chrome. Account, focused, admin,
 * redirect, and viewport-owned workspaces keep their own interaction model and
 * must never be covered by the floating popup.
 */
export function canRenderChatPopup(location: string): boolean {
  const route = findRouteMeta(location);

  return route?.layout === 'public'
    && route.disposition === 'keep';
}
